/**
 * Schema of Administrador
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {datetime} from 'simpli-web-sdk'
import Administrador from '@/model/resource/Administrador'

export default (model: Administrador): Schema => ({
  idAdministradorPk: {
    content: model.idAdministradorPk,
    editable: false,
  },

  nome: {
    content: model.nome,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  email: {
    content: model.email,
    input: InputType.EMAIL,
    meta: {
      required: true,
    },
  },

  senha: {
    content: model.senha,
    hidden: true,
    input: InputType.PASSWORD,
    meta: {
      required: true,
    },
  },

  dataCriacao: {
    content: datetime(model.dataCriacao),
    input: InputType.DATETIME,
    meta: {
      required: true,
    },
  },
})
